import { render } from "./trader-block.vue?vue&type=template&id=954710ee&scoped=true"
import script from "./trader-block.vue?vue&type=script&lang=js"
export * from "./trader-block.vue?vue&type=script&lang=js"

import "./trader-block.vue?vue&type=style&index=0&id=954710ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-954710ee"]])

export default __exports__